import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  CenterActivity,
  CenterActivityFilters
} from '../../../lib/types/models/center-activity/center-activity'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterActivities(
  id: number,
  input: PaginationRequest<CenterActivityFilters> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<CenterActivityFilters>>(
        constructApiUrl(API.centers.getCenterActivities.url, { id }),
        input
      )
    )
    .get<PaginationResponse<CenterActivity>>()
}
